module.exports = __webpack_public_path__ + "static/media/light-icon-sending-order.01e869cf.png";